import React, { Component } from 'react';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import LOOKUP from 'constants/lookup';
import { Link } from 'react-router-dom';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import ToggleInput from 'screens/components/basic/ToggleInput';
import SelectInput from 'screens/components/basic/SelectInput';

class CouponSave extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const couponTypes = LOOKUP.menu.admin.coupon.discountTypes;
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li><Link to={LOOKUP.menu.admin.coupon.link}>{LOOKUP.menu.admin.coupon.text}</Link></li>
                    <li className="active">{LOOKUP.menu.admin.coupon.controls.addNewButton}</li>
                </ol>
                <h2>{LOOKUP.menu.admin.coupon.controls.addNewButton}</h2>
            </div>
        )

        return (
            <ContainerDivided headerContent={header}>
                <CardSimple title="Coupon">
                    <div className="row">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                fullWidth={true}
                                name="couponName"
                                floatingLabelText={LOOKUP.menu.admin.coupon.labels.couponName.label}
                                hintText={LOOKUP.menu.admin.coupon.labels.couponName.label}
                                maxLength={20} />
                        </div>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-2">
                            <ToggleInput className="coupon_status" name="couponStatus" label="Status" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <DatePickerInput
                                name="startDate"
                                floatingLabelText={LOOKUP.menu.admin.coupon.labels.startDate.label}
                                hintText={LOOKUP.menu.admin.coupon.labels.startDate.label}
                                fullWidth={true} />
                        </div>
                        <div className="col-lg-6">
                            <DatePickerInput
                                name="endDate"
                                floatingLabelText={LOOKUP.menu.admin.coupon.labels.endDate.label}
                                hintText={LOOKUP.menu.admin.coupon.labels.endDate.label}
                                fullWidth={true} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <SelectInput name="discountType"
                                label={LOOKUP.menu.admin.coupon.labels.discountType.label}
                                floatingLabelText={LOOKUP.menu.admin.coupon.labels.discountType.label}
                                hintText={LOOKUP.menu.admin.coupon.labels.discountType.hintText}
                                options={couponTypes}
                                fullWidth={true} />
                        </div>
                        <div className="col-lg-6">
                            <TextInput
                                fullWidth={true}
                                name="discountValue"
                                floatingLabelText={LOOKUP.menu.admin.coupon.labels.discountValue.label}
                                hintText={LOOKUP.menu.admin.coupon.labels.discountValue.label}
                                maxLength={20} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <TextInput
                                fullWidth={true}
                                name="discountCode"
                                floatingLabelText={LOOKUP.menu.admin.coupon.labels.discountCode.label}
                                hintText={LOOKUP.menu.admin.coupon.labels.discountCode.label}
                                maxLength={20} />
                        </div>
                    </div>
                </CardSimple>
                <br />
                <div className="row">
                    <div className="col-lg-12">
                        <Button name="buttonSave"
                            className="pull-right"
                            label={LOOKUP.menu.admin.coupon.controls.saveButton}
                            primary={true} />
                        <Button name="buttonCancel"
                            className="pull-right btn-space"
                            label={LOOKUP.common.cancel.text} />
                    </div>
                </div>
            </ContainerDivided>
        );
    }
}

export default CouponSave;